// ©2024 Austin App House. All rights reserved.
import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { toggleModal } from '../../storage/actions/modalsActions';

class PortalContainer extends React.Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
    const className = props.className || 'portal-element';
    className.split(/\s+/).filter(Boolean).forEach((cls) => {
      this.el.classList.add(cls);
    });
  }

  componentDidMount() {
    const root = document.body;
    this.portalRoot = root;
    root.appendChild(this.el);
  }

  componentWillUnmount() {
    if (this.props.modalState[this.props.modalName]?.isOpen) {
      this.props.toggleModal(false, this.props.modalName);
    }
    if (this.portalRoot?.contains(this.el)) {
      this.portalRoot.removeChild(this.el);
    }
    this.props.closeModal && this.props.closeModal();
  }

  onClickOutside = () => {
    const { modalName, modalState, toggleModal } = this.props;
    const hasOtherOpen = Object.keys(modalState).some(
      (key) => key !== modalName && modalState[key]?.isOpen,
    );
    toggleModal(false, modalName, hasOtherOpen);
  };

  render() {
    const isOpen = this.props.modalState[this.props.modalName]?.isOpen;
    const children = isOpen
      ? (
        <>
          <div
            className="wurqly-modal-backdrop"
            onClick={this.onClickOutside}
            role="presentation"
          />
          {this.props.children}
        </>
      )
      : null;
    return ReactDOM.createPortal(
      children,
      this.el,
    );
  }
}

const mapStateToProps = state => ({
  modalState: state.modalState,
});

export default connect(mapStateToProps, { toggleModal })(PortalContainer);
